import { Injectable } from '@angular/core';
import { ApiService } from '../core/services/api.service';

import {
  ProjectPlanModel,
  ProjectPlanFolderModel,
} from '../models/projectplan.model';
import { ProjectPhotoAnnotationModel } from '../models/projectphoto.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProjectplanService {
  constructor(private apiService: ApiService) { }

  // Project Plan Operations

  /**
   * Create a new project plan
   */
  addProjectPlanFolder(planData: ProjectPlanFolderModel): Observable<number> {
    return this.apiService.post('ProjectPlan/AddProjectPlanFolder', planData);
  }

  getProjectPlans(projectId: number): Observable<ProjectPlanFolderModel[]> {
    return this.apiService.get(`ProjectPlan/GetProjectPlans/${projectId}`);
  }

   addProjectPlan(planData: any): Observable<number> {
    return this.apiService.post('ProjectPlan/CreateProjectPlan', planData);
  }

  /**
   * Update project plan
   */
  updateProjectPlan(plan: ProjectPlanModel): Observable<boolean> {
    return this.apiService.put('ProjectPlan/UpdateProjectPlan', plan);
  }

  /**
  * Delete project plan
  */
  deleteProjectPlan(planId: number): Observable<any> {
    return this.apiService.delete(`ProjectPlan/DeleteProjectPlan/${planId}`);
  }
  

  /**
   * Get project plan folder by ID
   */
  getProjectPlanFolderById(planFolderId: number): Observable<ProjectPlanFolderModel> {
    return this.apiService.get(`ProjectPlan/GetProjectPlanFolder/${planFolderId}`);
  }

  /**
   * Get all project plan folders for a project
   */
  getProjectPlanFoldersByProject(projectId: number): Observable<ProjectPlanFolderModel[]> {
    return this.apiService.get(`ProjectPlan/GetProjectPlanFolders/${projectId}`);
  }

  /**
   * Get project plan folder tree structure
   */
  getProjectPlanFolderTree(projectId: number): Observable<ProjectPlanFolderModel[]> {
    return this.apiService.get(`ProjectPlan/GetProjectPlanFolderTree/${projectId}`);
  }

  getProjectPlanAnnotation(planId: number): Observable<ProjectPhotoAnnotationModel> {
    return this.apiService.get(`ProjectPlan/GetProjectPlanAnnotation/${planId}`);
  }

  updateProjectPlanAnnotation(planId: number, annotationXfdf: string | null): Observable<any> {
    return this.apiService.put(`ProjectPlan/UpdateProjectPlanAnnotation/${planId}`, { annotationXfdf });
  }

  downloadProjectPlan(planId: number, optimized: boolean): Observable<Blob> {
    return this.apiService.getBlob(`ProjectPlan/DownloadProjectPlan/${planId}?optimized=${optimized}`);
  }


  /**
   * Delete project plan folder
   */
  deleteProjectPlanFolder(planFolderId: number): Observable<any> {
    return this.apiService.delete(`ProjectPlan/DeleteProjectPlanFolder/${planFolderId}`);
  }

}
